import * as React from 'react'
import { connect } from 'react-redux'
import {Link} from 'react-router-dom'
import { fetchRecording } from  './../redux/actions/visits'
import Page from './../components/shared/page'
import NewNote from './../components/note/newNote.js'
import arrow from './../images/left-arrow-circle.png'
import './../styles/note/note.css'

var strftime = require('strftime')

class Note extends React.Component {
  constructor() {
    super()

    this.state = {
      recording: null
    }
  }

  componentDidMount() {
    const id = Number(this.props.match.params.id)
    this.props.fetchRecording(id)
  }

  licensePlateCheck = (num) => {
    if(num === null) {
      return 'No Plate Read'
    } else {
      return num
    }
  }

  render () {
    const { recording } = this.props.visits
    return (
      <Page history={this.props.history} >
      {recording &&
        <div className='note-inner-container'>
          <div className='note-top'>
            <Link to={`/recordings/${recording.id}`}>
              <div className='note-back-button'>
                <img src={arrow} alt='To'/>
                <p>Back to video</p>
              </div>
            </Link>
            <p id='top-line'>
              Circle the area in question and add any notes
            </p>
            <div>
              <p id='review-license-plate'>
                <b>License:</b>
                {recording.visit.license_plate && ' ' + this.licensePlateCheck(recording.visit.license_plate)}
              </p>
              <p>
                <b>Date:</b>
                {recording.visit.triggered_at && ' ' + strftime('%D %I:%M %p', new Date(recording.visit.triggered_at))}
              </p>
              <p>
                <b>Bay:</b>
                {recording.visit.bay && ' ' + recording.visit.bay}
              </p>
              <p>
                <b>Angle:</b>
                {recording.angle_name && ' ' + recording.angle_name}
              </p>
            </div>
          </div>
          <div className='note-bottom'>
            <div className='video-player'>
              <NewNote
                recording={recording}
                screenshot={this.props.location.state.screenshot}
                zoomScreenshot={this.props.location.state.zoomScreenshot}
                history={this.props.history}/>
            </div>
            </div>
          </div>
      }
      </Page>
    )
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch)=> {
  return {
    fetchRecording: (id) => {
      return dispatch(fetchRecording(id));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Note)



// WEBPACK FOOTER //
// ./src/pages/note.js